import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';

export default function BusinessBasicInfoComponent ({handleInnerFormChange, businessDetails}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <div>
             <InputLabelContainer
          label="Business Id"
      />
  <InputLabelContainer
      label={businessDetails?.BusinessId}
  /></div>
  <div>  <InputLabelContainer
          label="Business Name"
      />
  <InputLabelContainer
      label={businessDetails?.BusinessName}
  /></div>

       <div> <InputLabelContainer
          label="Business PhoneNumber"
      />
  <InputLabelContainer
      label={businessDetails?.BusinessPhoneNumber}
  /></div>
  <div> <InputLabelContainer
          label="Business OwnerUser Id"
      />
  <InputLabelContainer
      label={businessDetails?.BusinessOwnerUserId}
  />
</div>
<div>  <InputLabelContainer
          label="Business OwnerEmplyoee Id"
      />
  <InputLabelContainer
      label={businessDetails?.BusinessOwnerEmplyoeeId}
  /></div>
  <div>  <InputLabelContainer
          label="Stage2 Business Registration Completed"
      />
  <InputLabelContainer
      label={businessDetails?.IsStage2BusinessRegistrationCompleted}
  /></div>
  <div> <InputLabelContainer
          label="Stage3 Business RegistrationCompleted"
      />
  <InputLabelContainer
      label={businessDetails?.IsStage3BusinessRegistrationCompleted}
  />
</div>
<div>  <InputLabelContainer
          label="Primary Tenant Business Management PortalUrl"
      />
  <InputLabelContainer
      label={businessDetails?.PrimaryTenantBusinessManagementPortalUrl}
  /></div>
  <div>  <InputLabelContainer
          label="Number Of Tenants"
      />
  <InputLabelContainer
      label={businessDetails?.Tenants?.NumberOfTenants}
  /></div>
  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>
        </>
  )
}